/**
 * Gallery Block JavaScript
 */
console.log('Gallery block script loaded successfully! ✅');
import Swiper from 'swiper';
import 'swiper/css';
import { Navigation } from 'swiper/modules';

export function initGallerySwiper(rootElement = document) {
  const swipers = rootElement.querySelectorAll('.swiper');

  swipers.forEach((swiperElement) => {
    if (swiperElement.dataset.galleryInitialized === 'true') {
      return;
    }

    const swiper = new Swiper(swiperElement, {
        modules: [Navigation],
        slidesPerView: 1.2,
        spaceBetween: 15,
        

      navigation: {
        nextEl: swiperElement.closest('.gallery-block').querySelector('.swiper-next'),
        prevEl: swiperElement.closest('.gallery-block').querySelector('.swiper-prev'),
      },

        breakpoints: {  
            640: {  
                slidesPerView: 1.3,
                spaceBetween: 20,
            },
            1024: {  
                slidesPerView: 1.6,
                spaceBetween: 25,
                centeredSlides: true, 
            },
             1700: {  
                slidesPerView: 2.4,
                spaceBetween: 30,
                centeredSlides: true, 
            },
        },
    });

    swiperElement.dataset.galleryInitialized = 'true';

    if (swiper) {
      console.log('Swiper initialized successfully');
    } else {
      console.error('Swiper initialization failed');
    }
  });
}